
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { SocialLinks } from "@/components/SocialLinks";

export function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-400 py-16">
      <div className="container mx-auto px-6">
        {/* Logo & tagline */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-12 pb-10 border-b border-gray-800 gap-6">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-brand-primary rounded-2xl flex items-center justify-center text-white text-2xl shadow-lg">
              ⚜️
            </div>
            <div>
              <p className="text-white font-extrabold text-lg leading-tight font-primary">Clínica de Nutrição Equilíbrio</p>
              <p className="text-gray-400 text-sm font-primary">Dra. Brenda Ramos · CRN/3-63492</p>
            </div>
          </div>
          <p className="title-special text-xl text-brand-softOrange max-w-sm">
            Cuidar com ciência, ouvir com empatia & nutrir com equilíbrio.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-8">
          {/* EMPRESA */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">EMPRESA</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/sobre" className="text-gray-300 hover:text-brand-primary transition-colors">
                  Nossa História
                </Link>
              </li>
              <li>
                <Link to="/servicos" className="text-gray-300 hover:text-brand-primary transition-colors">
                  Serviços
                </Link>
              </li>
              <li>
                <Link to="/sitemap" className="text-gray-300 hover:text-brand-primary transition-colors">
                  Mapa do Site
                </Link>
              </li>
            </ul>
          </div>

          {/* PACIENTES */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">PACIENTES</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/logins" className="text-gray-300 hover:text-brand-primary transition-colors">
                  Área do Paciente
                </Link>
              </li>
              <li>
                <Link to="/avaliacoes" className="text-gray-300 hover:text-brand-primary transition-colors">
                  Avaliação de Caso
                </Link>
              </li>
            </ul>
          </div>

          {/* CONTEÚDO */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">CONTEÚDO</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-brand-primary transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contato" className="text-gray-300 hover:text-brand-primary transition-colors">
                  Contato
                </Link>
              </li>
              <li>
                <Link to="/imprensa" className="text-gray-300 hover:text-brand-primary transition-colors">
                  Imprensa
                </Link>
              </li>
            </ul>
          </div>

          {/* CONSULTÓRIOS */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">CONSULTÓRIOS</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/consultorios" className="text-gray-300 hover:text-brand-primary transition-colors flex items-center">
                  <MapPin className="w-4 h-4 mr-2" />
                  Av. Paulista
                </Link>
              </li>
              <li>
                <Link to="/consultorios" className="text-gray-300 hover:text-brand-primary transition-colors flex items-center">
                  <MapPin className="w-4 h-4 mr-2" />
                  Cidade Mogi das Cruzes
                </Link>
              </li>
              <li>
                <Link to="/consultorios" className="text-gray-300 hover:text-brand-primary transition-colors flex items-center">
                  <MapPin className="w-4 h-4 mr-2" />
                  Cidade Suzano
                </Link>
              </li>
            </ul>
          </div>

          {/* REDES SOCIAIS */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">ME SIGA NAS REDES</h3>
            <SocialLinks />
          </div>
        </div>

        {/* Direitos Reservados */}
        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-300 mb-2 text-sm sm:text-base">
            © 2026 Dra Brenda Ramos - Nutricionista responsável CRN: 3/63492 | CNPJ: 55.373.902/0001-65
          </p>
          <p className="text-gray-400 text-xs sm:text-sm">
            Desenvolvimento por{" "}
            <a
              href="https://www.finalogica.com.br"
              target="_blank"
              rel="noopener noreferrer"
              className="text-brand-primary hover:text-brand-secondary transition-colors"
            >
              Finalógica Soluções
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
